import React, { useEffect, useState } from 'react';

interface BaseImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
	alt: string;
	errorImage: string;
	sourceImage: string;
	loadingImage?: string;
}

const BaseImage = ({ alt, errorImage, loadingImage, sourceImage, ...rest }: BaseImageProps) => {
	const [currentSrc, setCurrentSrc] = useState<string>(loadingImage || sourceImage);

	useEffect(() => {
		if (!sourceImage || sourceImage.trim() === '') {
			setCurrentSrc(errorImage);

			return;
		}

		const img = new Image();

		img.src = sourceImage;

		img.onload = () => setCurrentSrc(sourceImage);
		img.onerror = () => setCurrentSrc(errorImage);

		return () => {
			img.onload = null;
			img.onerror = null;
		};
	}, [sourceImage, errorImage]);

	return <img src={currentSrc} alt={alt} {...rest} />;
};

export default BaseImage;
